import HealthReportList from './List'

export default function HealthReportListIndex(props) {
  return <HealthReportList {...props} />
}
